import { useEffect, useRef } from 'react';
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import FormContainer from '../components/FormContainer';
import Loader from '../components/Loader';
import Message from '../components/Message';
import { useConfirmLinePayMutation } from '../slices/ordersApiSlice';

// LINE Pay redirects here after the user approves:
//   /order/:id/linepay/confirm?transactionId=...&orderId=...
// We ask OUR server to confirm (capture) — the browser never marks an order paid.
const LinePayConfirmScreen = () => {
  const { id: orderId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [confirmLinePay, { error }] = useConfirmLinePayMutation();

  // Read as a string: 19 digits > Number.MAX_SAFE_INTEGER, never Number() it.
  const transactionId = searchParams.get('transactionId');

  // Confirm must run once (StrictMode double-effect / double click safety).
  const sent = useRef(false);

  useEffect(() => {
    if (sent.current || !transactionId) return;
    sent.current = true;

    (async () => {
      try {
        await confirmLinePay({ orderId, transactionId }).unwrap();
        toast.success('LINE Pay 付款成功');
        navigate(`/order/${orderId}`, { replace: true });
      } catch (err) {
        toast.error(err?.data?.message || err.error);
      }
    })();
  }, [orderId, transactionId, confirmLinePay, navigate]);

  if (!transactionId || error) {
    return (
      <FormContainer>
        <h1>LINE Pay</h1>
        <Message variant="danger">
          {error?.data?.message || '找不到 LINE Pay 交易資訊'}
        </Message>
        <Link to={`/order/${orderId}`}>返回訂單</Link>
      </FormContainer>
    );
  }

  return (
    <FormContainer>
      <h1>正在確認 LINE Pay 付款…</h1>
      <Loader />
    </FormContainer>
  );
};

export default LinePayConfirmScreen;
